import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=37caa50d&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=ts"
export * from "./ContactUs.vue?vue&type=script&lang=ts"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=37caa50d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37caa50d",
  null
  
)

export default component.exports